export const studentsOptions = [
  {
    label: 'Écoles Marseille - Maternelle',
    value: 'Écoles Marseille - Maternelle',
  },
  {
    label: 'Écoles Marseille - CP, CE1, CE2',
    value: 'Écoles Marseille - CP, CE1, CE2',
  },
  {
    label: 'Écoles Marseille - CM1, CM2',
    value: 'Écoles Marseille - CM1, CM2',
  },
  { label: 'Collège - 6e', value: 'Collège - 6e' },
  { label: 'Collège - 5e', value: 'Collège - 5e' },
  { label: 'Collège - 4e', value: 'Collège - 4e' },
  { label: 'Collège - 3e', value: 'Collège - 3e' },
  { label: 'Lycée - Seconde', value: 'Lycée - Seconde' },
  { label: 'Lycée - Première', value: 'Lycée - Première' },
  { label: 'Lycée - Terminale', value: 'Lycée - Terminale' },
  { label: 'CAP - 1re année', value: 'CAP - 1re année' },
  { label: 'CAP - 2e année', value: 'CAP - 2e année' },
]

export const studentsForData = [
  {
    label: 'Écoles Marseille - Maternelle',
    value: 'Écoles Marseille - Maternelle',
  },
  {
    label: 'Écoles Marseille - CP, CE1, CE2',
    value: 'Écoles Marseille - CP, CE1, CE2',
  },
  {
    label: 'Écoles Marseille - CM1, CM2',
    value: 'Écoles Marseille - CM1, CM2',
  },
  { label: 'Collège - 6e', valueForData: 'Collège sixième' },
  { label: 'Collège - 5e', valueForData: 'Collège cinquième' },
  { label: 'Collège - 4e', valueForData: 'Collège quatrième' },
  { label: 'Collège - 3e', valueForData: 'Collège troisième' },
  { label: 'Lycée - Seconde', valueForData: 'Lycée seconde' },
  { label: 'Lycée - Première', valueForData: 'Lycée première' },
  { label: 'Lycée - Terminale', valueForData: 'Lycée terminale' },
  { label: 'CAP - 1re année', valueForData: 'CAP première année' },
  { label: 'CAP - 2e année', valueForData: 'CAP deuxième année' },
]
